export function vehiculeRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_VEHICULE_START":           
        case "FETCH_VEHICULES_START":                                 
        case "UPDATE_VEHICULE_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_VEHICULE_FULFILLED":           
        case "FETCH_VEHICULES_FULFILLED":                                 
        case "UPDATE_VEHICULE_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_VEHICULE_ERROR":
        case "FETCH_VEHICULES_ERROR":
        case "UPDATE_VEHICULE_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}